import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PackageService } from '../models/package-service.model';
import { PackageItem } from '../models/package-item.model';
import { PackageServiceBalanceDTO } from '../models/dtos/package-service-balance-DTO';
import { PackageConsumptionHistoryDTO } from '../models/dtos/package-consumption-history-DTO';
import { PackageConsumptionHistoryRequestDTO } from '../models/dtos/package-consumption-history-request-DTO';
import { PackageConsumptionHistoryResponseDTO } from '../models/dtos/package-consumption-history-response-DTO';
import { environment } from '../../environments/environment';

interface PackageServicePayload {
  name: string;
  description?: string;
  daysDuration: number;
  active: boolean;
  productId: number;
  items?: PackageItemCreateDTO[];
}

interface PackageItemCreateDTO {
  productId: number;
  quantity: number;
}

@Injectable({
  providedIn: 'root'
})
export class PackageServiceService {

  private baseUrl = environment.apiHost + '/api-core/secure/package-service';

  constructor(private http: HttpClient) { }

  // Métodos para PackageService
  findAll(): Observable<PackageService[]> {
    return this.http.get<PackageService[]>(this.baseUrl);
  }

  findById(id: number): Observable<PackageService> {
    return this.http.get<PackageService>(`${this.baseUrl}/${id}`);
  }

  findByMarinaId(marinaId: number): Observable<PackageService[]> {
    return this.http.get<PackageService[]>(`${this.baseUrl}/marina/${marinaId}`);
  }

  findActiveByMarinaId(marinaId: number): Observable<PackageService[]> {
    return this.http.get<PackageService[]>(`${this.baseUrl}/marina/${marinaId}/active`);
  }

  create(packageService: PackageService | PackageServicePayload): Observable<PackageService> {
    return this.http.post<PackageService>(this.baseUrl, packageService);
  }

  update(id: number, packageService: PackageService | PackageServicePayload): Observable<PackageService> {
    return this.http.put<PackageService>(`${this.baseUrl}/${id}`, packageService);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  activate(id: number): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/activate`, {});
  }

  deactivate(id: number): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/deactivate`, {});
  }

  findItemsByPackageServiceId(packageServiceId: number): Observable<PackageItem[]> {
    return this.http.get<PackageItem[]>(`${this.baseUrl}/${packageServiceId}/items`);
  }

  // addItem(packageServiceId: number, packageItem: PackageItem): Observable<PackageItem> {
  //   return this.http.post<PackageItem>(`${this.baseUrl}/${packageServiceId}/items`, packageItem);
  // }

  // deleteItem(itemId: number): Observable<void> {
  //   return this.http.delete<void>(`${this.baseUrl}/items/${itemId}`);
  // }

  addPackageInBoat(payload: any): Observable<any> {
    console.log('Payload enviado para addPackageInBoat:', payload);
    return this.http.post<any>(`${this.baseUrl}/add-boat`, payload);
  }

  getPackageServiceBalanceByBoatId(boatId: number): Observable<PackageServiceBalanceDTO[]> {
    return this.http.get<PackageServiceBalanceDTO[]>(`${this.baseUrl}/balance/${boatId}`);
  }

  getPackageConsumptionHistory(payload: PackageConsumptionHistoryRequestDTO, marinaId: number): Observable<PackageConsumptionHistoryResponseDTO[]> {
    return this.http.post<PackageConsumptionHistoryResponseDTO[]>(
      `${this.baseUrl}/package-boat/consumption-history`,
      payload,
      { headers: { 'Marinaid': marinaId.toString() } }
    );
  }
}
